import { put, call, takeLatest, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import _ from 'lodash';

import { request, pagableRequest } from 'api';
import { getFilterParams, showMessage } from 'utils/helpers';
import { TYPE, ACTION } from './actions';
import * as selectors from './selectors';

function* fetchByAccountsTransactionsHandler({ payload = {} }) {
    try {
        const filters = yield select(selectors.filters);

        yield put(ACTION.fetchByAccountsTransactionsLoading());

        const res = yield call(pagableRequest(payload), {
            url: '/transactions/clients',
            params: getFilterParams(filters)
        });

        yield put(ACTION.fetchByAccountsTransactionsSuccess(res.data));
    } catch (err) {
        yield put(ACTION.fetchByAccountsTransactionsError(err));
        console.error(err);
    }
}

function* exportToExcel() {
    try {
        const filters = yield select(selectors.filters);
        showMessage({ type: 'warning', message: 'Почалося завантаження звіту - це може зайняти деякий час.' });

        const res = yield call(request, {
            responseType: 'arraybuffer',
            url: '/transactions/clients/export',
            params: getFilterParams(filters),
        });

        const contentDisposition = _.get(res, 'headers.content-disposition', 'filename=report.xls');
        const [, filename] = contentDisposition.match(/filename=(.*)/);

        const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(TYPE.FETCH_BY_ACCOUNTS_TRANSACTIONS, fetchByAccountsTransactionsHandler),
    takeLatest(TYPE.EXPORT_TO_EXCEL, exportToExcel),
];
